export default __webpack_public_path__ + "static/media/OSM-slider2.c6f1506a.jpg";